"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcPageDataList = void 0;
var ac_ui_1 = require("@aperza/ac-ui");
var client_1 = require("@apollo/client");
var json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AcPageDataListContext_1 = require("./AcPageDataListContext");
var AcPageDataList = function (props) {
    var query = props.query, columns = props.columns, pathToPage = props.pathToPage, pageSizes = props.pageSizes, enableExpandAll = props.enableExpandAll, expandAllName = props.expandAllName, expandableRow = props.expandableRow, highlight = props.highlight, hoverable = props.hoverable, onRowClick = props.onRowClick, onRowExpand = props.onRowExpand, onRowCollapse = props.onRowCollapse, activeData = props.activeData, whenNoData = props.whenNoData, topActionBarWhenNoData = props.topActionBarWhenNoData, whenLoading = props.whenLoading, grid = props.grid, refetchTimestamp = props.refetchTimestamp, toolbar = props.toolbar, filterBar = props.filterBar, topActionBar = props.topActionBar, onDataChange = props.onDataChange, withDownloadButtons = props.withDownloadButtons, onDownloadClick = props.onDownloadClick, onUploadClick = props.onUploadClick, hidePagination = props.hidePagination, hideHeader = props.hideHeader, enableCustomHeaderSelector = props.enableCustomHeaderSelector, enableAllRecordsSelector = props.enableAllRecordsSelector, selectedRowCount = props.selectedRowCount, rowClassName = props.rowClassName, rowGap = props.rowGap, expandRowWithoutTrTag = props.expandRowWithoutTrTag, renderRowsOnly = props.renderRowsOnly, bottomActionBar = props.bottomActionBar;
    var acPageDataListContext = AcPageDataListContext_1.useAcPageDataListContext();
    var hidePageStatus = acPageDataListContext.hidePageStatus, hidePageSizeSelector = acPageDataListContext.hidePageSizeSelector, hideToolbar = acPageDataListContext.hideToolbar;
    var page = (props === null || props === void 0 ? void 0 : props.page) || (acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.page);
    var onChangePage = (props === null || props === void 0 ? void 0 : props.onChangePage) || (acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.updatePage);
    var size = (props === null || props === void 0 ? void 0 : props.size) || (acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.pageSize);
    var onChangePageSize = (props === null || props === void 0 ? void 0 : props.onChangeSize) || (acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.updatePageSize);
    var sorts = (props === null || props === void 0 ? void 0 : props.sorts) || (acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.sorts);
    var onChangeSorts = (props === null || props === void 0 ? void 0 : props.onChangeSorts) || (acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.updateSorts);
    var filter = (props === null || props === void 0 ? void 0 : props.filter) || (acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.filter);
    var _a = __read(react_1.useState(false), 2), previewOpened = _a[0], setPreviewOpened = _a[1];
    var location = react_router_dom_1.useLocation();
    // TODO to abstract this as previewFaxDocumentId is efax domain.
    var previewFaxDocumentId = react_router_dom_1.useParams().previewFaxDocumentId;
    var setPage = function (currentPage) {
        if (onChangePage)
            onChangePage(currentPage);
    };
    var setSize = function (currentSize) {
        if (onChangePageSize)
            onChangePageSize(currentSize);
    };
    var setSorts = function (currentSorts) {
        if (onChangeSorts)
            onChangeSorts(currentSorts);
    };
    var loading = acPageDataListContext.loading, data = acPageDataListContext.queryData, refetch = acPageDataListContext.refetch, client = acPageDataListContext.client, networkStatus = acPageDataListContext.networkStatus, refetchPage = acPageDataListContext.refetchPage, getPageData = acPageDataListContext.getPageData;
    var refetchFirstPage = function () {
        if (page === 1) {
            return refetchPage();
        }
        setPage(1);
        return Promise.resolve();
    };
    react_1.useEffect(function () {
        refetchPage();
    }, [page, size, json_stable_stringify_1.default(filter), json_stable_stringify_1.default(sorts)]);
    /**
     * Filter change. Set page = 1
     */
    // useEffect(() => {
    //   refetchFirstPage()?.then();
    // }, [filter]);
    /**
     * To force refresh the page, set location.state.refetch = true
     * TODO check sending location.state.refetch = true twice will not refresh (no state change)
     */
    react_1.useEffect(function () {
        if (location.state && location.state.refetch) {
            refetchFirstPage();
        }
    }, [location.state]);
    react_1.useEffect(function () {
        if (refetchTimestamp > 0) {
            refetchFirstPage();
        }
    }, [refetchTimestamp]);
    var getPageContent = function () {
        var pageData = getPageData();
        if (pageData) {
            return pageData.content;
        }
        return [];
    };
    var getPageNumber = function () {
        var pageData = getPageData();
        if (pageData) {
            return pageData.page;
        }
        return 1;
    };
    var getPageSize = function () {
        var pageData = getPageData();
        if (pageData) {
            return pageData.size;
        }
        return 10;
    };
    var getTotalElements = function () {
        var pageData = getPageData();
        if (pageData) {
            return pageData.totalElements;
        }
        return 0;
    };
    var onSort = function (columnId, direction) {
        setSorts([[columnId, direction]]);
    };
    var onClickPage = function (_page) {
        setPage(_page);
    };
    var onSelectPageSize = function (_pageSize) {
        setSize(_pageSize);
        setPage(1); // reset to first page after the pagesize is set
    };
    var isLoading = function () { return loading || networkStatus === client_1.NetworkStatus.refetch; };
    react_1.useEffect(function () {
        acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.setData(getPageContent());
        if (onDataChange) {
            var pageData = getPageData();
            onDataChange(pageData);
        }
    }, [data]);
    var acDataListPageData = react_1.useMemo(function () { return getPageData(); }, [data]);
    var acDataListData = react_1.useMemo(function () { return getPageContent(); }, [data]);
    // Add mock data here
    // include only the array in the "content" section
    // const acDataListData = [...]
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !renderRowsOnly && !hideToolbar && (!hidePagination || toolbar || filterBar) && (react_1.default.createElement("div", { className: "d-flex flex-row mb-3 align-items-center" },
            !hidePagination && !hidePageStatus && (react_1.default.createElement(ac_ui_1.AcPaginationInfo, { page: page, size: size, totalElements: getTotalElements() })),
            react_1.default.createElement("div", { className: "ml-auto d-flex flex-row" },
                toolbar,
                !hidePagination && !hidePageSizeSelector && size > 0 && onChangePageSize && (react_1.default.createElement(ac_ui_1.AcTablePageSizeDropdown, { pageSize: size, pageSizes: pageSizes, updatePageSize: onSelectPageSize })),
                filterBar && react_1.default.createElement("div", { className: "ml-3" }, filterBar)))),
        react_1.default.createElement(ac_ui_1.AcDataList, { data: acDataListData, activeData: activeData, functionContext: {
                page: page,
                size: size,
                filter: filter,
                pageData: acDataListPageData,
                client: client,
                refetch: refetch,
                externalState: acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.externalState,
                expandedDataIds: acPageDataListContext === null || acPageDataListContext === void 0 ? void 0 : acPageDataListContext.expandedDataIds,
            }, loading: loading, columns: columns, grid: grid, onSort: onSort, sorts: sorts, enableExpandAll: enableExpandAll, topActionBar: topActionBar, expandAllName: expandAllName, expandableRow: expandableRow, highlight: highlight, hoverable: hoverable, page: getPageNumber(), pageSizes: pageSizes, size: size !== null && size !== void 0 ? size : getPageSize(), onSelectPageSize: onSelectPageSize, totalElements: getTotalElements(), onClickPage: onClickPage, onRowClick: onRowClick, onRowExpand: onRowExpand, onRowCollapse: onRowCollapse, whenLoading: whenLoading, whenNoData: whenNoData !== null && whenNoData !== void 0 ? whenNoData : undefined, topActionBarWhenNoData: topActionBarWhenNoData, hidePagination: hidePagination, hideHeader: hideHeader, enableCustomHeaderSelector: enableCustomHeaderSelector, enableAllRecordsSelector: enableAllRecordsSelector, selectedRowCount: selectedRowCount, rowClassName: rowClassName, rowGap: rowGap, expandRowWithoutTrTag: expandRowWithoutTrTag, renderRowsOnly: renderRowsOnly, bottomActionBar: bottomActionBar })));
};
exports.AcPageDataList = AcPageDataList;
exports.AcPageDataList.displayName = 'AcPageDataList';
//# sourceMappingURL=AcPageDataList.js.map